import React from 'react';
import { View, Text, TextInput, TouchableOpacity, StyleSheet } from 'react-native';
import { CustomSettingsIcon } from './FencingIcons';

export default function GeneralSettingsCard({ numTeams, setNumTeams, stoccate, setStoccate }) {
  // Aggiorna il numero di squadre
  const handleNumTeams = (delta) => {
    const newVal = Math.max(2, numTeams + delta);
    setNumTeams(newVal);
  };

  return (
    <View style={styles.card}>
      <View style={styles.titleRow}>
        <CustomSettingsIcon style={{ fontSize: 18, color: '#1976d2', marginRight: 4 }} />
        <Text style={styles.title}>Impostazioni generali</Text>
      </View>
      <View style={styles.fieldBlock}>
        <Text style={styles.fieldLabel}>Numero squadre</Text>
        <View style={styles.inputRow}>
          <TextInput
            style={styles.inputFull}
            value={String(numTeams)}
            keyboardType="numeric"
            onChangeText={val => setNumTeams(Math.max(2, parseInt(val) || 2))}
          />
          <TouchableOpacity style={styles.roundBtn} onPress={() => handleNumTeams(-1)} disabled={numTeams <= 2}>
            <Text style={styles.roundBtnText}>-</Text>
          </TouchableOpacity>
          <TouchableOpacity style={styles.roundBtn} onPress={() => handleNumTeams(1)}>
            <Text style={styles.roundBtnText}>+</Text>
          </TouchableOpacity>
        </View>
      </View>
      <View style={styles.fieldBlock}>
        <Text style={styles.fieldLabel}>Stoccate per assalto</Text>
        <View style={styles.inputRow}>
          <TextInput
            style={styles.inputFull}
            value={String(stoccate)}
            keyboardType="numeric"
            onChangeText={val => setStoccate(Math.max(1, parseInt(val) || 1))}
          />
          <TouchableOpacity style={styles.roundBtn} onPress={() => setStoccate(Math.max(1, stoccate - 1))} disabled={stoccate <= 1}>
            <Text style={styles.roundBtnText}>-</Text>
          </TouchableOpacity>
          <TouchableOpacity style={styles.roundBtn} onPress={() => setStoccate(stoccate + 1)}>
            <Text style={styles.roundBtnText}>+</Text>
          </TouchableOpacity>
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  card: {
    backgroundColor: '#fff',
    borderRadius: 18,
    boxShadow: '0 4px 24px #0002',
    padding: 16,
    marginVertical: 12,
    borderWidth: 2,
    borderColor: '#1976d2',
    transition: 'box-shadow 0.2s',
    maxWidth: '100vw',
    overflowX: 'auto',
  },
  titleRow: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 8,
    gap: 8
  },
  icon: {
    fontSize: 18,
    marginRight: 4
  },
  title: {
    fontSize: 17,
    fontWeight: 'bold',
    color: '#1976d2',
    marginBottom: 0,
    marginLeft: 0,
  },
  label: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#333',
    marginRight: 10,
    marginBottom: 6
  },
  fieldBlock: {
    marginBottom: 18
  },
  fieldLabel: {
    fontSize: 14,
    color: '#1976d2',
    marginBottom: 2,
    marginLeft: 2,
    fontWeight: 'bold',
    letterSpacing: 0.1
  },
  inputRow: {
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
    gap: 8
  },
  btnCol: {
    flexDirection: 'row',
    marginLeft: 8,
    gap: 6
  },
  inputFull: {
    borderWidth: 2,
    borderColor: '#b3c6e6',
    borderRadius: 8,
    backgroundColor: '#f4faff',
    fontWeight: 'bold',
    fontSize: 17,
    flex: 1,
    minWidth: 0,
    paddingVertical: 10,
    paddingHorizontal: 14,
    textAlign: 'center',
  },
  roundBtn: {
    backgroundColor: '#1976d2',
    borderRadius: 18,
    width: 36,
    height: 36,
    alignItems: 'center',
    justifyContent: 'center',
    marginHorizontal: 6,
    shadowColor: '#1976d2',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.18,
    shadowRadius: 4,
    elevation: 2
  },
  roundBtnText: {
    color: '#fff',
    fontWeight: 'bold',
    fontSize: 22,
    textAlign: 'center',
    lineHeight: 22
  },
  inputNum: {
    borderWidth: 2,
    borderColor: '#b3c6e6',
    borderRadius: 8,
    backgroundColor: '#f4faff',
    fontWeight: 'bold',
    fontSize: 17,
    minWidth: 60,
    maxWidth: 80,
    textAlign: 'center',
    marginHorizontal: 8,
    paddingVertical: 10,
    paddingHorizontal: 8,
  },
  cat: {
    fontWeight: 'bold',
    color: '#1976d2',
    fontSize: 15,
    minWidth: 80,
    marginRight: 10
  },
  stoccateLabel: {
    color: '#333',
    fontSize: 14
  }
});
